import React, { useState } from 'react'
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/esm/Container';


export default function TextForm(props) {
    function handleEntailmentRequest(e) {
        e.preventDefault();
    }
    
    function handleOnClickUC() {
        let newText = text.toUpperCase();
        setText(newText);
        props.ShowAlert("success", "Converted Upper Case!")
    }
    function handleOnChange(event) {
        setText(event.target.value);
    }
    function handleOnClickLC() {
        const newText = text.toLowerCase();
        setText(newText);
        props.ShowAlert("success", "Converted Lower Case!")
    }
    function handleOnClickSen() {
        var newString = text.toLowerCase().replace(/(^\s*\w|[./?/!]\s*\w)/g, function (c) {
            return c.toUpperCase()
        });
        setText(newString);
        props.ShowAlert("success", "Converted To Sentance Case!")
    }
    function handleOnClickCap() {
        const newText = text.toLowerCase().replace(/(\b[a-zA-Z])/g, function (c) {
            return c.toUpperCase()
        });
        setText(newText);
        props.ShowAlert("success", "Converted To Capitalize Case!")
    }
    function handleOnClickClear() {
        setText("");
        props.ShowAlert("success", "Text Cleared!")
    }
    const [text, setText] = useState("");
    return (
        <>
            <Container style={{ color: props.mode === 'dark' ? 'white' : 'black' }}>
                <Form onSubmit={handleEntailmentRequest}>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label className="mb-3 h1">Enter Your Text</Form.Label>
                        <Form.Control style={{ background: props.mode === 'dark' ? '#74808c' : 'white', color: props.mode === 'dark' ? 'white' : 'black' }} as="textarea" value={text} rows={8} placeholder="Enter Here" onChange={handleOnChange} autoFocus />
                        <Form.Text style={{ color: props.mode === 'dark' ? 'white' : 'black' }}>
                            We'll never share your data.
                        </Form.Text>
                    </Form.Group>
                    <Button variant={props.buttonType} type="submit" className='mx-1 mt-2' onClick={handleOnClickUC}>
                        Convert to Uppercase
                    </Button>
                    <Button variant={props.buttonType} type="submit" className='mx-1 mt-2' onClick={handleOnClickLC}>
                        Convert to Lowercase
                    </Button>
                    <Button variant={props.buttonType} type="submit" className='mx-1 mt-2' onClick={handleOnClickSen}>
                        Sentence Case
                    </Button>
                    <Button variant={props.buttonType} type="submit" className='mx-1 mt-2' onClick={handleOnClickCap}>
                        Capitilize
                    </Button>
                    <Button variant={props.buttonType} type="submit" className='mx-1 mt-2' onClick={handleOnClickClear}>
                        Clear Text
                    </Button>
                </Form>
            </Container>
            <Container className='display-7 my-4' style={{ color: props.mode === 'dark' ? 'white' : 'black' }}>
                <h1>Text Summary</h1>
                <p>Total Words: {text.split(" ").length - 1} and Total Characters: {text.length}</p>
            </Container>
        </>
    );
}
